import React, { Fragment, useState, useEffect, useContext } from 'react';
import useLaborCost from '../../../../../../hooks/useLaborCost';
import { APPConstants } from '../../../../../../constants/app';
import { ProjectContext } from '../../../../../../context/Project';
import { formatPrice } from '../../../../../../common/numberFormat';
import { Spinner } from 'reactstrap';

function LaborCost() {
    const { projectMaterials, projectPostalCode, getPostalCode, setLaborBudget } = useContext(ProjectContext);
    const laborCostManager = useLaborCost();

    const [laborCost, setLaborCost] = useState(0);
        
    useEffect(() => {
        const postalCode = getPostalCode();
        if (projectMaterials && postalCode) {
            let materialList = Object.keys(projectMaterials).map((materialId) => {
                let material = projectMaterials[materialId];
                if (!material.materialId) {
                    material.materialId = materialId;
                }
                return material;
            });

            if (materialList.length > 0) {
                laborCostManager.estimateLaborBudget(
                    APPConstants.COUNTRY_ID,
                    postalCode,
                    materialList
                );
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectMaterials, projectPostalCode]);

    useEffect(() => {
        if (laborCostManager.laborCost) {
            let laborBudget = laborCostManager.laborCost?.laborBudget
            setLaborCost(laborBudget);
            setLaborBudget(laborBudget);
        } else {
            setLaborCost(0);
            setLaborBudget(0);
            if (laborCost.error) {
                console.log(laborCostManager.error);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [laborCostManager.laborCost]);

    return (
        <Fragment>
            {
                projectMaterials && (Object.keys(projectMaterials).length > 0 && !laborCostManager.error) &&
                <Fragment>
                    <span>Labor cost</span>
                    {
                        !laborCostManager.loading &&
                        <Fragment>
                            {
                                !laborCostManager.error &&
                                <Fragment>
                                    {
                                        (laborCost > 0) &&
                                        <span>{formatPrice(laborCost)}</span>
                                    }
                                    {
                                        !laborCost &&
                                        <span className='col-6 align-content-center text-start advice alert alert-warning'>
                                            Please enter zip code to calculate
                                        </span>
                                    }
                                </Fragment>
                            }
                            {
                                laborCostManager.error &&
                                <span>-</span>
                            }
                        </Fragment>
                    }
                    {
                        laborCostManager.loading &&
                        <Fragment>
                            <span>
                                <Spinner size='sm' />
                            </span>
                        </Fragment>
                    }
                
                </Fragment>
            }
            {
                <Fragment>
                    {
                        (projectMaterials && laborCostManager.error) &&
                        <Fragment>
                            <span className='col advice alert alert-warning'>
                                We couldn't estimate a labor budget at this moment
                            </span>
                        </Fragment>
                    }
                </Fragment>
            }
        </Fragment>
    );
}

export default LaborCost;